const EducatorAvatarWithTopicColor = ({
  iconBgColor,
  bgColor,
  strokeColor
}) => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_802_16557)">
        <path
          d="M0 30C0 13.4315 13.4315 0 30 0C46.5685 0 60 13.4315 60 30C60 46.5685 46.5685 60 30 60C13.4315 60 0 46.5685 0 30Z"
          fill={bgColor}
          fillOpacity="0.2"
        />
        <path
          d="M14.4445 32.9445C14.4445 41.5356 21.409 48.5001 30.0001 48.5001C38.5912 48.5001 45.5556 41.5356 45.5556 32.9445V31.849C45.5556 31.1347 44.9766 30.5557 44.2623 30.5557H15.7378C15.0235 30.5557 14.4445 31.1347 14.4445 31.849V32.9445Z"
          fill={iconBgColor}
        />
        <path
          d="M21.6111 19.8057C21.6111 24.4234 25.367 28.1668 30 28.1668C34.6331 28.1668 38.3889 24.4234 38.3889 19.8057C38.3889 15.188 34.6331 11.4446 30 11.4446C25.367 11.4446 21.6111 15.188 21.6111 19.8057Z"
          fill={iconBgColor}
        />
        <path
          opacity="0.2"
          d="M77.55 46.1609L63.9371 66.151L57.1937 49.1627L44.0869 69.5247"
          stroke={strokeColor}
          strokeWidth="15.5556"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.2"
          d="M15.05 -7.58911L1.43709 12.401L-5.30635 -4.5873L-18.4131 15.7747"
          stroke={strokeColor}
          strokeWidth="15.5556"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M35.1464 34.0802C35.3003 35.0419 36.1459 35.7773 37.166 35.7773C38.1758 35.7773 39.0146 35.0567 39.1807 34.1093C39.202 34.0204 39.2108 33.9494 39.2081 33.8885C39.2081 33.8188 39.1573 33.7646 39.087 33.7646H35.2468C35.1765 33.7646 35.1258 33.8187 35.1257 33.8883C35.1259 33.8884 35.1255 33.8883 35.1257 33.8883C35.1258 33.8899 35.1254 33.8914 35.1255 33.893C35.1237 33.946 35.1304 34.0068 35.1464 34.0802Z"
          fill="white"
        />
        <path
          d="M38.1698 37.0436C38.0929 36.5627 37.67 36.195 37.16 36.195C36.6551 36.195 36.2357 36.5553 36.1526 37.029C36.142 37.0735 36.1376 37.109 36.1389 37.1394C36.1389 37.1743 36.1643 37.2014 36.1995 37.2014H38.1196C38.1547 37.2014 38.1801 37.1743 38.1801 37.1395C38.1801 37.1395 38.1802 37.1395 38.1801 37.1395C38.1801 37.1387 38.1803 37.138 38.1802 37.1372C38.1811 37.1107 38.1778 37.0803 38.1698 37.0436Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_802_16557">
          <path
            d="M0 30C0 13.4315 13.4315 0 30 0C46.5685 0 60 13.4315 60 30C60 46.5685 46.5685 60 30 60C13.4315 60 0 46.5685 0 30Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default EducatorAvatarWithTopicColor;
